export default __webpack_public_path__ + "locales/sr-Cyrl-RS/OAuth.json?hash=3f5613def57099a03e7538e10e25493a";